'use strict';

module.exports = require('./matrix').Matrix;
module.exports.Decompositions = module.exports.DC = require('./decompositions');



//////////////////
// WEBPACK FOOTER
// ./~/ml-pls/~/ml-matrix/src/index.js
// module id = 47
// module chunks = 0